import { useAdmin } from '../../hooks/useAdmin';
import { menuItems } from '../../config/menuItems';
import MenuCard from '../shared/MenuCard';
import LandingNavbar from '../shared/LandingNavbar';
import CustomerNavbar from '../shared/CustomerNavbar';
import CustomerFooter from '../shared/CustomerFooter';
import { MULTI_TENANT_ENABLED } from '../../config/features';
import './LandingPage.css';

const LandingPage = () => {
  const { isAdmin, enabledCards, loading, isCustomer } = useAdmin();
  const basePath = MULTI_TENANT_ENABLED && isCustomer ? '/customer' : '';

  const visibleItems = menuItems.filter(item =>
    (item.live || item.comingSoon) &&
    (!item.adminOnly || isAdmin || item.comingSoon) &&
    (!MULTI_TENANT_ENABLED || !enabledCards || enabledCards.includes(item.id))
  );

  return (
    <div className="landing-page-container">
      {loading ? null : isCustomer ? <CustomerNavbar /> : <LandingNavbar />}

      {!loading && isCustomer && (
        <div className="customer-hero-wrapper">
          <header className="customer-hero">
            <img src="/static/customer-login-page-image.jpg" alt="" className="customer-hero-img" />
            <div className="customer-hero-overlay">
              <h1 className="customer-hero-heading">Digital pest control management</h1>
              <p className="customer-hero-text">Take your pest management to new levels of efficiency with digital pest control solutions from Rentokil. By combining sensor technology and wireless communications with unrivalled expertise, pest data analysis and reporting, you can proactively manage and prevent pest infestations. Whether you have a single site or multiple sites globally, Rentokil's digital pest management allows monitor pest activity via state-of-the-art pest control.</p>
            </div>
          </header>
        </div>
      )}

      {!loading && !isCustomer && (
        <div className="landing-content-max">
          <div className="service-panel">
            <h2 className="service-panel-title">Beta Features</h2>
          </div>
        </div>
      )}

      <main className="landing-cards-section">
        <div className="landing-content-max">
          <div className="card-grid-wrapper">
            {!loading && isCustomer && enabledCards && enabledCards.length === 0 ? (
              <p style={{ color: 'var(--text-muted, #aaa)', marginTop: '2rem' }}>No features have been enabled for your account.</p>
            ) : (
              !loading && visibleItems.map((item, index) => (
                <MenuCard
                  key={item.id}
                  title={item.title}
                  description={item.description}
                  icon={item.icon}
                  path={item.path}
                  comingSoon={item.comingSoon}
                  isAdmin={isAdmin}
                  index={index}
                  basePath={basePath}
                />
              ))
            )}
          </div>
        </div>
      </main>

      {isCustomer && (
        <div className="customer-pre-footer landing-pre-footer">
          <nav className="landing-pre-footer-links">
            <a href="https://www.rentokil.com/company-information" className="landing-pre-footer-link" target="_blank" rel="noopener noreferrer">Company information</a>
            <a href="https://www.rentokil.com/legal" className="landing-pre-footer-link" target="_blank" rel="noopener noreferrer">Legal statement</a>
            <a href="https://www.rentokil-initial.com/site-services/cookie-and-privacy-policy/privacy-policy.aspx" className="landing-pre-footer-link" target="_blank" rel="noopener noreferrer">Privacy policy</a>
            <a href="https://www.rentokil-initial.com/site-services/cookie-and-privacy-policy/cookie-policy.aspx" className="landing-pre-footer-link" target="_blank" rel="noopener noreferrer">Cookie policy</a>
          </nav>
          <img src="/static/rentokil-logo.png" alt="Rentokil" className="customer-rentokil-logo" />
        </div>
      )}
      {isCustomer && <CustomerFooter />}
    </div>
  );
};

export default LandingPage;
